var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-container',[_c('el-header',[_c('nav-header')],1),_vm._v(" "),_c('el-main',[_c('div',[_c('h1',[_vm._v("我们是您身边的投资顾问，为您的每一次投资提供趋势研判！")])])]),_vm._v(" "),_c('el-header',[_c('h2',[_vm._v("版权归北京买点科技有限责任公司所有")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68509aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs.vue
// module id = null
// module chunks = 